const c = {
  name: "Hands00000",
  dimensions: { width: 26, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 30" style="enable-background:new 0 0 26 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.2,2.7C6.8,1.1,8.3,0,10,0c1.7,0,3.2,1.1,3.8,2.7C14.4,2.2,15.2,2,16,2c1.7,0,3.2,1.1,3.8,2.7
			C20.4,4.2,21.2,4,22,4c2.2,0,4,1.8,4,4v9c0,7.2-5.8,13-13,13S0,24.2,0,17V6c0-2.2,1.8-4,4-4C4.8,2,5.6,2.2,6.2,2.7z M24,11V8
			c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2C23.1,13,24,12.1,24,11z M19.8,14.3c-0.5,1.6-2,2.7-3.8,2.7
			c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4H6v-2h4c1.1,0,2-0.9,2-2s-0.9-2-2-2H4c-1.1,0-2,0.9-2,2v4c0,6.1,4.9,11,11,11
			c6.1,0,11-4.9,11-11v-2.5c-0.6,0.3-1.3,0.5-2,0.5C21.2,15,20.4,14.8,19.8,14.3z M18,6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v7
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V6z M12,9.5V4c0-1.1-0.9-2-2-2C8.9,2,8,2.9,8,4v5h2C10.7,9,11.4,9.2,12,9.5z M6,9V6
			c0-1.1-0.9-2-2-2C2.9,4,2,4.9,2,6v3.5C2.6,9.2,3.3,9,4,9H6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands00000
};
